import React, { useContext, useEffect, useRef } from "react";
import "../../../ui-styles/calling/incomingCallModal.css";
import "../../../ui-styles/animations/callAnimation.css";

import { LangCtx } from "../../../lib/context";
let ring = null;
const IncommingCall = (props) => {

    const { l } = useContext(LangCtx);
    const ringRef = useRef();
    // console.log("props ==== ", props.userData);

    const fetchDevices = async (videoStats, audioStats) => {
        try {
            if (!navigator.mediaDevices?.enumerateDevices) {
                console.log("enumerateDevices() not supported.");
            } else {
                let constraints = {
                    audio: audioStats,
                    video: videoStats
                }
                // if (videoStats) {
                //     constraints['video'] = {
                //         width: { min: 640 },
                //         height: { min: 480 }
                //       }
                // }
                console.log("constraints ==== ", constraints);
                const media = await navigator.mediaDevices.getUserMedia(constraints);
                let devicesList = await navigator.mediaDevices.enumerateDevices();
                return devicesList;
            }
        } catch (err) {
            console.log("err === ", err);
        }
    }
    useEffect(() => {
        // console.log("enter into use effect");
        // console.log("ringRef === ", ringRef, ringRef.current);
        fetchDevices(true, true).then(res => {
            console.log("res === ", res);
            let cdefaultDevice = res.find(obj => obj.kind === 'videoinput');
            console.log("cdefaultDevice ==== ", cdefaultDevice);
                cdefaultDevice && cdefaultDevice.deviceId && localStorage.setItem('camera', cdefaultDevice.deviceId);
            let mdefaultDevice = res.find(obj => obj.kind === 'audioinput');
            console.log("mdefaultDevice ==== ", mdefaultDevice);
                mdefaultDevice && mdefaultDevice.deviceId && localStorage.setItem('mic', mdefaultDevice.deviceId);
        }).catch(err => {
            fetchDevices(false, true).then(response => {
                // console.log("response === ", response);
                let defaultDevice = response.find(obj => obj.kind === 'audioinput');
                defaultDevice && defaultDevice.deviceId && localStorage.setItem('mic', defaultDevice.deviceId);
            });
        })
        if (ringRef && ringRef.current) {
            let ua = navigator.userAgent.toLowerCase();
            // console.log("ua ==== ", ua);
            let is_safari = (ua.indexOf("safari/") > -1 && ua.indexOf("chrome") < 0);
            // console.log("is_safari ==== ", is_safari);
            if (is_safari) {
                setTimeout(() => {
                    ringRef.current.play().then(() => {
                        console.log("ring play success");
                    }).catch(err => {
                        console.log("ring play err === ", err);
                    });
                }, 50);
            } else {
                ringRef.current.play().then(() => {
                    console.log("ring play success");
                }).catch(err => {
                    console.log("ring play err === ", err);
                });
            }
        }
    }, [])
    // useEffect(() => {
    //     if (props.inCall && ring === null) {
    //         ring = new Audio('/audio/phone_ringing.mp3');
    //         ring.loop = true;
    //         // ring.playsinline = true;
    //         ring.play();
    //     } else {
    //         ring.pause();
    //         ring.currentTime = 0
    //         ring.src = '';
    //         ring.loop = false;
    //         ring = null;
    //     }
    //     return () => {
    //         if (ring) {
    //             ring.pause();
    //             ring.currentTime = 0
    //             ring.src = '';
    //             ring.loop = false;
    //             ring = null;
    //         }
    //     }
    // }, [props.inCall]);
    return (
        <div className={props.inCall ? "callModalCntnr showModal" : "callModalCntnr"}>
            <div className="callingCntnr">
                <div className="callingTB topHight">
                    <div className="callingHdr">
                        <span className="callHdrLTxt">{l.incmng_call}...</span>
                    </div>

                </div>

                <div className="callingBdy">
                    <div className="callAnimation">
                        <img src={props && props.userData && props.userData.profileImage && props.userData.profileImage.url ? props.userData.profileImage.url : "/images/pics/m1.jpg"} alt="profile pic" className="profilePic" />
                    </div>
                    <span className="nameTxt">{`Dr. ${props && props.userData && props.userData.firstName ? props.userData.firstName : ''}`}</span>
                    {/* <audio controls ref={ringRef} loop>
                        <source src="/audio/phone_ringing.ogg" type="audio/ogg" />
                        <source src="/audio/phone_ringing.mp3" type="audio/mpeg" />
                        Your browser does not support the audio tag.
                    </audio> */}
                    <audio src="/audio/phone_ringing.mp3" className="noVisible" preload="metadata" ref={ringRef} autoPlay loop playsInline />
                </div>

                <div className="callingTB btmHight">
                    <div className="callingFtr">
                        <div className="circleBtnItem">
                            <button className="callBtnItem endBtn" onClick={props.handleInCall}>
                                <img src="/images/icons/phone.png" className="invertWhite" alt="icon" />
                            </button>
                            <span className="btnTxt">{l.decline}</span>
                        </div>
                        <div className="circleBtnItem">
                            <button className="callBtnItem answerBtn" onClick={props.handleAccept}>
                                <img src="/images/icons/call-phone.png" className="invertWhite" alt="icon" />
                            </button>
                            <span className="btnTxt">{l.answer}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default IncommingCall;